export default {"src":"/_next/static/media/mada-payment-logo.2afc2eff.svg","height":16,"width":47,"blurWidth":0,"blurHeight":0};